import React from 'react'
import s from './HowItWorks.module.css'
import Image from "next/legacy/image"

export interface IListForm {
  content: string
  title: string
}

export interface HowItWorksProps {
  title?: string
  image?: any
  children: any
  color?: string
}

const HowItWorks: React.FC<HowItWorksProps> = ((props) => {
  const {
    title,
    color,
    children,
    image
  } = props

  return (
    <div className={`${s.root}`} style={(color ? {backgroundColor: color} : {})}>
      <div>
        <div className={`${s.grid} grid grid-cols-1 lg:grid-cols-2 h-full`}>
          <div className={'hidden lg:block'}>
            {image && <div
              className='block w-full h-full block overflow-hidden relative'>
              <Image alt='How it workt desktop image' priority={false} loading="lazy" src={image} layout='fill' objectFit='cover' />
            </div>}
          </div>
          <div className={'lg:hidden'}>
            {image && <div
              className={s.imageMobile + ' block w-full h-full block overflow-hidden relative'}>
              <Image alt='How it works mobile image' src={image} layout={'fill'} objectFit='cover'/>
            </div>}
          </div>
          <div className='mx-space6 md:mx-space16 py-space8 md:py-16'>
            <div className={s.titleCover + ' lg:pb-20 lg:mb-20'}>
              <h3 className={`${s.title}`}>{title}</h3>
            </div>
            <div className={'md:pr-space22'}>
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
})

export default HowItWorks
